// extracted by mini-css-extract-plugin
export default {"base":"base-YIF6Q","item":"item-Dfxob","cycle":"cycle-RlRmV","text":"text-RyQ93"};